<template>
  <v-card>
    <v-toolbar color="blue-grey white--text">
      <!-- <v-icon>contacts</v-icon> -->
      <v-toolbar-title class="white--text">ประเภทบุคคล</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <v-btn color="teal" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่มประเภทบุคคล</span>
      </v-tooltip>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      hide-actions
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">
          <v-icon color="green" v-if="props.item.insider">done</v-icon>
          <v-icon color="red" v-else>clear</v-icon>
        </td>
        <td class="text-xs-left">{{ props.item.remark }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip left>
            <v-btn icon class="mx-0" slot="activator" @click="viewItem(props.item)">
              <v-icon color="teal">pageview</v-icon>
            </v-btn>
            <span>ดูข้อมูล</span>
          </v-tooltip>

          <v-tooltip left>
            <v-btn icon class="mx-0" slot="activator" @click="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>ลบข้อมูล</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <template>
      <component :is="formDialog" :dialog="dialog" :item="selectedItem" :title="title" @dialog="dialog = $event"></component>
    </template>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
import PersonTypeFormDialog from './formDialog.vue'

export default {
  components: {
  PersonTypeFormDialog
},
  data () {
    return {
      dialog: false,
      formDialog:null,
      title: null,
      loading: false,
      headers: [
        {
          text: 'ประเภทบุคคล',
          align: 'left',
          sortable: true,
          value: 'name'        },
        { text: 'บุคลากรภายใน', value: 'insider', sortable: false},
        { text: 'หมายเหตุ', value: 'remark', sortable: false},
        { sortable: false }
      ],
      items: [],
      selectedItem: {}
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    addItem () {
      this.title = 'เพิ่มประเภทบุคคล'
      this.formDialog = 'person-type-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    viewItem (item) {
      this.selectedItem = item
      this.title = 'แก้ไขประเภทบุคคล'
      this.formDialog = 'person-type-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    deleteItem (item) {
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          this.$store.dispatch('personType/delete', item)
            .then((response) => {
                console.log('reload:', response )
                this.reload()
              }).catch((error) => {
                swal('Error!', error.message, 'error')
              })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    reload () {
      this.loading = true
      this.$store.dispatch('personType/loadItems')
        .then((response) => {
          console.log('reload:', response )
          this.items = response.data
          this.loading = false
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reset () {
      this.selectedItem = {}
    }
  },
  watch: {
    dialog (val) {
      console.log('watching dialog... val: ' + val)
      if(!val) {
        setTimeout(()=>{
          this.reset()
          this.formDialog = null
        }, 300)
        this.reload()
      }

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/settings/personType/index.vue